import type { ChildGuideItem } from '@tunein/web-api-client';

export function generateRoutePathForGuideItem(guideItem: ChildGuideItem) {
  const path = guideItem.seoInfo?.cleanPath || guideItem.destinationInfo?.cleanPath || '';

  return path && guideItem.isTopic && guideItem.guideId
    ? `${path}?topicId=${guideItem.guideId.slice(1)}`
    : path;
}
